import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import BusinessNavbar from 'components/Navbars/BusinessNavbar'
import RatingList from 'components/Lists/RatingList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, Title } from '../styles'

export default function BusinessRatings () {
  const [loading, setLoading] = useState (true)
  const [businessRatings, setBusinessRatings] = useState ([])
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getBusinesses ()
  }, [])

  const getBusinesses = async () => {
    try {
      setLoading (true)
      const { data: businessRatings } = await cutileiApi.get (
        `/businesses/${businessId}/ratings`, requestConfig
      )
      setBusinessRatings (businessRatings)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  return (
    <Container>
      <BusinessNavbar/>
      <Title>Suas avaliações</Title>
      {loading ? <Loading/> : (
        <RatingList ratings={businessRatings}/>
      )}
    </Container>
  )
}
